"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorContents = ErrorContents;
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorContents(_ref) {
  var error = _ref.error,
      pretty = _ref.pretty;

  if (!error) {
    return null;
  }

  var message = error.message ? typeof error.message === 'string' ? error.message : JSON.stringify(error.message, null, 2).replace(/^\"\"$/, '') : null;

  if (pretty) {
    message = /*#__PURE__*/_react.default.createElement("pre", null, message);
  }

  if (error instanceof Error) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, message && /*#__PURE__*/_react.default.createElement("div", {
      className: "message"
    }, message), error.stack && /*#__PURE__*/_react.default.createElement("div", {
      className: "stack"
    }, error.stack));
  }

  if (error.status) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "status"
    }, error.status), message && /*#__PURE__*/_react.default.createElement("div", {
      className: "message"
    }, message), error.stack && /*#__PURE__*/_react.default.createElement("div", {
      className: "stack"
    }, error.stack));
  }

  return JSON.stringify(error);
}

function _default(props) {
  var error = props.error,
      className = props.className;

  if (!error) {
    return null;
  }

  var classes = ['error'];

  if (className) {
    classes.push(className);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' ')
  }, /*#__PURE__*/_react.default.createElement(ErrorContents, props));
}